/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import SideBarLayout from "./layout/SideBarLayout";
import { Navbar, Footer, Sidebar, ThemeSettings } from "./components";
import {
  Dashboard,
  Orders,
  RevenueReport,
  ProfitReport,
  PendingOrders,
  DeliveredOrders,
  ShippedOrders,
  ProcessingOrders,
  CenceledOrders,
  ViewOrderDetails,
  CustomerSupport,
  ReplyToCustomer,
  SendEmail,
  Notification,
  Stacked,
  Pyramid,
  Customers,
  Product,
  OldBooks,
  AddProduct,
  EditProduct,
  ViewProduct,
  Categories,
  AddCategory,
  EditCategory,
  TopRated,
  FlashSale,
  AddSale,
  EditSale,
  Login,
  Banners,
  AddBanner,
  Cuppons,
  AddCuppons,
  EditCuppon,
  DeliveryCharges,
  NotConfiremedOrders,
  HomePage, NewHomePage,
  CustomersOrders,
  DeletedCustomers,
  SellerList
} from "./pages";
import "./App.css";

import { useStateContext } from "./contexts/ContextProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ApisContext } from "./contexts/ApiConterxt";
import { AuthContext } from "./contexts/Auth.Context";
import { Navigate } from "react-router-dom/dist";

import Landing from "./layout/Landing";
import BooksRequests from "./pages/BookRequests";
import LogsList from "./pages/LogsList";
import ViewLogDetails from "./pages/ViewLogDetails";
import BookcatalogPage from "./pages/BookcatalogPage";

const App = () => {
  const { state: ContextState } = useContext(ApisContext);

  const { state: AuthContextState } = useContext(AuthContext);

  const { isLoginPending } = AuthContextState;
  const [loading, setLoading] = useState(false);
  const { isPending } = ContextState;
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode") || "blue";
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // loading ? document.body.style.overflow = 'hidden': document.body.style.overflow = '';
    setLoading(isPending || isLoginPending);
  }, [isPending, isLoginPending]);

  return (
    <div className={`${loading ? " h-screen overflow-hidden" :""}`}>
      {loading && (
        <div
          style={{
            zIndex: "999999999",
          }}
          className="absolute  inset-y-0 bg-black bg-opacity-70 overflow-hidden inset-0 h-[100vh] w-full flex justify-center items-center"
        >
          <div role="status">
            <svg
              aria-hidden="true"
              style={{
                fill: currentColor,
              }}
              className="w-12 h-12 mr-2 text-gray-200 animate-spin dark:text-gray-600 "
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
      <div className={currentMode === "Dark" ? "dark" : ""}>
        <Routes>
        {/* <Route element={<Landing />} >
          <Route index element={<HomePage/>}></Route>
          <Route path="home" element={<NewHomePage/>}></Route>

        </Route> */}
          {/* dashboard  */}
          <Route
            element={
              <PrivateRoute>
                <SideBarLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="dashboard"/>} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="newBooks" element={<Product />} />
            <Route path="oldBooks" element={<OldBooks />} />
            <Route path="newbooks/addBook/:bookType/:catlog?" element={<AddProduct />} />
            <Route path="oldBooks/addBook/:bookType" element={<AddProduct />} />
            <Route
              path="books/editBook/:productId/:catlog?"
              element={<EditProduct />}
            />
            <Route
              path="books/viewBook/:productId"
              element={<ViewProduct />}
            />
            <Route path="oldBooks/addBook" element={<AddProduct />} />
            <Route
              path="oldBooks/editBook/:productId"
              element={<EditProduct />}
            />
            <Route
              path="oldBooks/viewBook/:productId"
              element={<ViewProduct />}
            />
            <Route
              path="orders/viewOrder/:orderId"
              element={<ViewOrderDetails />}
            />
            <Route path="orders" element={<Orders />} />
            <Route path="revenuereport" element={<RevenueReport />} />
            <Route path="profitreport" element={<ProfitReport />} />
            <Route path="pendingOrders" element={<PendingOrders />} />
            <Route path="notconfirmedorders" element={<NotConfiremedOrders />} />
            <Route path="deliveredorders" element={<DeliveredOrders />} />
            <Route path="shippedOrders" element={<ShippedOrders />} />
            <Route path="processingorders" element={<ProcessingOrders />} />
            <Route path="cancelledorders" element={<CenceledOrders />} />
            <Route path="requestbook" element={<BooksRequests />} />
            <Route path="customersOrders/:customerId" element={<CustomersOrders />} />
            <Route path="customersSupport" element={<CustomerSupport />} />
            <Route path="customersSupport/replyToCustomer/:chat_id" element={<ReplyToCustomer />} />
            <Route path="sendEmail" element={<SendEmail />} />
            <Route path="deliverycharges" element={<DeliveryCharges />} />
            <Route path="categories" element={<Categories />} />
            <Route path="categories/addCategory" element={<AddCategory />} />
            <Route
              path="categories/editCategory/:catId"
              element={<EditCategory />}
            />
            <Route path="topRated" element={<TopRated />} />
            <Route path="banners/addBanner" element={<AddBanner />} />
            <Route path="flashSale" element={<FlashSale />} />
            <Route
              path="coupons/editCoupon/:cupponId"
              element={<EditCuppon />}
            />
            <Route path="sellers">
              <Route index element={<SellerList />} />
            </Route>
            <Route path="coupons/addCoupon" element={<AddCuppons />} />
            <Route path="coupons" element={<Cuppons />} />
            <Route path="banners" element={<Banners />} />
            <Route path="Customers" element={<Customers />} />
            <Route path="deletedcustomers" element={<DeletedCustomers />} />
            <Route path="flashSale/addSale" element={<AddSale />} />
            <Route path="flashSale/editSale/:saleId" element={<EditSale />} />
            <Route path="notification" element={<Notification />} />
            <Route path="apilogs/" element={<LogsList />} />
            <Route path="bookcatalog" element={<BookcatalogPage />} />
            <Route path="apilogs/viewLog/:logId" element={<ViewLogDetails />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<div className="h-screen flex justify-center items-center bg-white dark:bg-gray-700">
            <div className="text-center"><p className="text-gray-800 font-bold leading-none dark:text-gray-50 text-xl">404 <br /><span className="text-base">Page Not Found</span></p></div>
          </div>} />
         
        </Routes>

        <ToastContainer />
      </div>
    </div>
  );
};

export default App;
